// profiles.store.js
import { observable, computed, action, runInAction, makeObservable } from "mobx";

import { axios } from "./utils/axios";

// const { NotificationManager } = require("react-notifications");

import Subject from "./subjects/subject";
import UserSubject from "./subjects/user_subject";

import { fetchSubjectsAction } from "./subjects/actions/fetch_subjects";
import { remove_subject } from "./subjects/actions/remove_subject";

import FetchedSubject from "./subjects/fetched_subject";
import FetchedSubjectScores from "./subjects/fetched_subject_scores";

import { QuizObject, QuizObjectCardTable } from './quiz_objects/quiz-object';
import { QuizUserSubjectTracking } from './subjects/quiz-user-subject-tracking';

interface IResponse {
    data: any;
    status: number;
}

export function subjectDetailFromResponse(body: any) {
    return body && body.data ? body.data : body;
}

export default class SubjectsStore {
    /* A list of all Subjects, such as in a search */
    @observable subjects = new Map();

    /* A list of subjects that a user has added to their profile */
    @observable userSubjects = new Map();

    @observable atomTracking: Array<any> = [];
    @observable subject: any = {};
    @observable state = "pending"; // "pending" / "done" / "error"
    @observable fetched_subjects: Array<FetchedSubject> = [];
    @observable fetched_subject_scores: Array<FetchedSubjectScores> = [];
    @observable fetch_in_progress: { [key: string]: boolean } = {};
    @observable rootStore: any;
    constructor(rootStore: any) {
        this.rootStore = rootStore;
        makeObservable(this);
    }

    @action.bound
    fetch() {
        if (!this.rootStore.profileStore.authTokenSet()) {
            return;
        }

        var store = this;
        var state = "pending";

        fetchSubjectsAction(store, function(
            userSubjects: Map<string, UserSubject>,
            state: string
        ) {
            runInAction(() => {
                console.log("Got User Subjects:")
                console.log(userSubjects);
                if (userSubjects) {
                    store.userSubjects = userSubjects;
                }
                store.state = state;
            });
        });
    }

    @action
    create(
        title: string,
        description: string,
        types: Array<string>,
        isPublic: boolean,
        cb: Function
    ) {
        axios()
            .post(`/subjects`, {
                title: title,
                description: description,
                types: types,
                public: isPublic
            })
            .then(function(res: any) {
                cb(true, res.data);
            })
            .catch(function(err: any) {
                const response = err?.response?.data;
                const errors = response?.errors;
                const firstError = errors && Object.values(errors).flat()[0];

                cb(false, {
                    title: response?.title || "Could not create subject",
                    detail:
                        response?.detail ||
                        response?.error ||
                        firstError ||
                        "The request could not reach Lrner. Please try again."
                });
            });
    }

    @action markComplete(
        subjectHashKey: any
    ) {
        const store = this;
        axios()
            .put(`/profile/subjects/${subjectHashKey}`, { enabled: false })
            .then((res: any) => {
                store.userSubjects.set(
                    subjectHashKey,
                    res.data.quiz_subjects[subjectHashKey]
                );
                // NotificationManager.success(
                //     "Click to Dismiss",
                //     `Marked subject ${res.data.quiz_subjects[subjectHashKey].title} complete`,
                //     5000,
                // );
            })
            .catch((err: any) => {
                // NotificationManager.error(
                //     "Click to Dismiss",
                //     `Sorry: ${err}.`,
                //     5000,
                // );
            });
    }

    updateUserHashKey(
        subjectHashKey: any,
        params: any,
        cb: Function
    ) {
        var store = this;
        axios()
            .put(`/subjects/${subjectHashKey}`, params)
            .then(function(res: any) {
                store.subjects.set(
                    `${subjectHashKey}`,
                    new Subject(
                        res.data.subject_spec.slug,
                        res.data.subject_spec,
                        []
                    )
                );
                cb(true);
            })
            .catch(function(err: any) {
                cb(false);
            });
    }


    updateHashKey(
        subjectHashKey: any,
        params: any,
        cb: Function
    ) {
        var store = this;
        axios()
            .put(`/subjects/${subjectHashKey}`, params)
            .then(function(res: any) {
                store.subjects.set(
                    `${subjectHashKey}`,
                    new Subject(
                        res.data.subject_spec.slug,
                        res.data.subject_spec,
                        []
                    )
                );
                cb(true);
            })
            .catch(function(err: any) {
                cb(false);
            });
    }

    @action
    update(
        userSlug: string,
        subjectSlug: string,
        params: string,
        cb: Function,
    ) {
        this.updateHashKey(`${userSlug}/${subjectSlug}`, params, cb);
    }

    @action.bound
    search(searchString?: string) {
            var store = this;
            this.subjects = new Map();
            this.state = "pending";

            console.log(this.state);
            axios()
                .get("/subjects")
                .then((res: any) => res.data)
                .then(function(res: any) {
                    Object.keys(res.subjects).forEach(function(subject) {
                        store.subjects.set(
                            res.subjects[subject].user + "/" + subject,
                            new Subject(subject, res.subjects[subject], [])
                        );
                    });
                    store.state = "done";
                })
                .catch((err: any) => {
                    console.log("ERROR");
                    console.log("in axios ", err);
                    store.state = "error";
                });
    }

    fetchFreeLanding() {
        var store = this;
        this.subjects = new Map();
        this.state = "pending";

        axios()
            .get("/subjects/free")
            .then((res: any) => res.data)
            .then(function(res: any) {
                Object.keys(res.subjects).forEach(function(subject) {
                    store.subjects.set(
                        res.subjects[subject].user + "/" + subject,
                        new Subject(subject, res.subjects[subject], [])
                    );
                });
                store.state = "done";
            })
            .catch((err: any) => {
                store.state = "error";
            });
    }

    public fetchOne(subjectUser: string, subjectSlug: string) {
        console.log(`Fetching subject with subject slug ${subjectUser}/${subjectSlug}`);
        if (this.fetch_in_progress[`${subjectUser}/${subjectSlug}`]) {
            return false;
        }

        console.log(this.fetch_in_progress);

        this.fetch_in_progress[`${subjectUser}/${subjectSlug}`] = true;
        const store = this;

        console.log(store.fetch_in_progress);
        const fetchedSubjectsList = this.fetched_subjects.map(function(
            fetched_subject: FetchedSubject
        ) {
            return fetched_subject.slug;
        });

        console.log(fetchedSubjectsList);

        if (fetchedSubjectsList.includes(subjectSlug)) {
            return false;
        }

        return axios()
            .get(`/subjects/${subjectUser}/${subjectSlug}`)
            .then(this.redirectIfNotLoggedIn)
            .then((body: any) => {
                const data = subjectDetailFromResponse(body);
                const fetchedSubject = new Subject(
                  subjectSlug,
                  data.subject,
                  data.objects,
                  data.permissions,
                );
                console.log(fetchedSubject);
                store.subjects.set(
                    `${subjectUser}/${subjectSlug}`,
                    fetchedSubject
                );

                store.fetchTracking(subjectUser, subjectSlug);

                store.fetched_subjects.push(
                    new FetchedSubject(subjectSlug, Date.now())
                );
                store.fetch_in_progress[`${subjectUser}/${subjectSlug}`] = false;
            })
            .catch((err: any) => {
                console.log(err);
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this subject.",
                //     5000
                // );
                store.state = "error";
            });
    }

    public fetchTracking(username: string, subjectSlug: string) {
        if (this.fetch_in_progress[`${username}/${subjectSlug}/tracking`]) {
            return false;
        }

        this.fetch_in_progress[`${username}/${subjectSlug}/tracking`] = true;
        const store = this;

        return axios()
            .get(`/subjects/${username}/${subjectSlug}/tracking`)
            .then(this.redirectIfNotLoggedIn)
            .then((body: any) => {
                const data = subjectDetailFromResponse(body);
                const subject = store.subjects.get(`${username}/${subjectSlug}`);
                if (subject) {
                    subject.setTracking(data.tracking);
                }
                store.fetch_in_progress[`${username}/${subjectSlug}/tracking`] = false;
            })
            .catch((err: any) => {
                store.fetch_in_progress[`${username}/${subjectSlug}/tracking`] = false;
                console.log(err);
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving the subject tracking.",
                //     5000
                // );
                store.state = "error";
            });
    }

    fetchOneUser(username: string, subjectSlug: string) {
        if (username == undefined || subjectSlug == undefined) {
            return;
        }
        var subject_hash_key: string = `${username}/${subjectSlug}`;
        if (this.fetch_in_progress[`profile/${subject_hash_key}`]) {
            return false;
        }

        this.fetch_in_progress[`profile/${subject_hash_key}`] = true;
        var store = this;

        var fetched_subject_list = this.fetched_subjects.map(function(
            fetched_subject
        ) {
            return fetched_subject.slug;
        });

        if (fetched_subject_list.includes(subject_hash_key)) {
            return false;
        }

        axios()
            .get(`/profile/subjects/${username}/${subjectSlug}`)
            .then(this.redirectIfNotLoggedIn)
            .then(function(body: any) {
                store.fetch_in_progress[subject_hash_key] = false;
                store.subjects.set(
                    subject_hash_key,
                    new Subject(subjectSlug, body.subject_info, [])
                );
                store.userSubjects.set(
                    subject_hash_key,
                    new UserSubject(
                        subjectSlug,
                        body.user_subject_info,
                        body.subject_info
                    )
                );
                store.fetched_subjects.push({
                    slug: subject_hash_key,
                    updated: Date.now()
                });
            })
            .catch(function(err: any) {
                store.fetch_in_progress[`profile/${subject_hash_key}`] = false;
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this subject.",
                //     5000
                // );
                store.state = "error";
            });
    }

    public fetchScores(subjectUser: string, subjectSlug: string) {
        const store = this;
        store.state = "pending";

        if (this.fetch_in_progress[`${subjectUser}/${subjectSlug}/scores`]) {
            return false;
        }

        this.fetch_in_progress[`${subjectUser}/${subjectSlug}/scores`] = true;

        const fetched_subject_score_list = this.fetched_subject_scores.map(function(
            fetched_subject: FetchedSubject,
        ) {
            return fetched_subject.slug;
        });

        if (fetched_subject_score_list.includes(subjectSlug)) {
            return false;
        }

        axios()
            .get(`/subjects/${subjectUser}/${subjectSlug}/scores`)
            .then(this.redirectIfNotLoggedIn)
            .then(function(body: any) {
                const data = subjectDetailFromResponse(body);
                store.rootStore.quizzerStore.quiz_user_subject_tracking = new QuizUserSubjectTracking(data.quiz_user_subject_tracking);
                store.fetched_subject_scores.push(
                    new FetchedSubject(subjectSlug, Date.now())
                );
                store.fetch_in_progress[`${subjectUser}/${subjectSlug}/scores`] = false;
                store.state = "done";
            })
            .catch(function(err: any) {
                console.log(err);
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this subject.",
                //     5000,
                // );
                store.state = "error";
            });
    }

    public fetchAtomScores(subjectUser: string, subjectSlug: string) {
        const store = this;
        store.state = "pending";

        if (this.fetch_in_progress[`${subjectUser}/${subjectSlug}/atom_scores`]) {
            return false;
        }

        this.fetch_in_progress[`${subjectUser}/${subjectSlug}/atom_scores`] = true;

        const fetched_subject_score_list = this.fetched_subject_scores.map(function(
            fetched_subject: FetchedSubject,
        ) {
            return fetched_subject.slug;
        });

        if (fetched_subject_score_list.includes(subjectSlug)) {
            return false;
        }

        axios()
            .get(`/subjects/${subjectUser}/${subjectSlug}/atom_scores`)
            .then(this.redirectIfNotLoggedIn)
            .then(function(body: any) {
                body.quiz_user_tracking.forEach((qut: any) => {
                    store.atomTracking.push(qut);
                });

                store.rootStore.quizzerStore.quiz_user_subject_tracking = new QuizUserSubjectTracking(body.quiz_user_subject_tracking);
                store.fetched_subject_scores.push(
                    new FetchedSubject(subjectSlug, Date.now())
                );
                store.fetch_in_progress[`${subjectUser}/${subjectSlug}/scores`] = false;
                store.state = "done";
            })
            .catch(function(err: any) {
                console.log(err);
                // NotificationManager.warning(
                //     "Click to Dismiss",
                //     "There was a problem retrieving this subject.",
                //     5000,
                // );
                store.state = "error";
            });
    }

    @action
    public resetStats(user: string, subject: string) {
        const subjectHashKey = `${user}/${subject}`;
        const store = this;

        axios()
            .post(`/subjects/${subjectHashKey}/actions/reset_stats`)
            .then((res: any) => {
                // NotificationManager.success(
                //     "Click to Dismiss",
                //     `Reset Stats for Subject ${res.data.quiz_subjects[subjectHashKey].title}.`,
                //     5000,
                // );
            })
            .catch((err: any) => {
                // NotificationManager.error(
                //     "Click to Dismiss",
                //     `Sorry: ${err}.`,
                //     5000,
                // );
            });

    }

    /*
     * Send a request to the server to add a new subject to the user's profile.
     * This is identified by subject_slug
     *
     * subject_slug string
     */
    @action
    addSubject(subjectHashKey: string) {
        const store = this;
        axios()
            .post(`/profile/subjects/${subjectHashKey}`)
            .then((res: any) => {
                store.userSubjects.set(
                    subjectHashKey,
                    res.data.quiz_subjects[subjectHashKey]
                );
                // NotificationManager.success(
                //     "Click to Dismiss",
                //     `Added subject ${res.data.quiz_subjects[subjectHashKey].title}.`,
                //     5000,
                // );
            })
            .catch((err: any) => {
                // NotificationManager.error(
                //     "Click to Dismiss",
                //     `Sorry: ${err}.`,
                //     5000,
                // );
            });
    }

    @action
    removeSubject(subject_hash_key: string) {
        var store = this;
        var state = "pending";

        remove_subject(
            this.userSubjects,
            this.userSubjects.get(subject_hash_key),
            function(userSubjects: Map<string, UserSubject>, state: string) {
                if (userSubjects) {
                    store.userSubjects = userSubjects;
                }

                store.state = state;
            }
        );
    }

    @action
    moveObject(subject_hash_key: string, move_object_id: string, after_object_id: string | undefined) {
        this.subjects.get(subject_hash_key).moveObject(move_object_id, after_object_id)
    }

    @action
    addObject(user: string, slug: string, object: any, optional_id?: any) {
        const subject_hash_key = `${user}/${slug}`;
        this.subjects.get(subject_hash_key).addObject(object, optional_id);
    }

    @action
    filter(string: string) {
        var store = this;
        this.subjects = new Map();
        this.state = "pending";

        axios()
            .get(`/subjects?query=${string}`)
            .then((res: any) => res.data)
            .then(function(res: any) {
                Object.keys(res.subjects).forEach(function(subject) {
                    store.subjects.set(
                        subject,
                        new Subject(subject, res.subjects[subject], [])
                    );
                });
                console.log("Done!");
                console.log(store.subjects);
                store.state = "done";
            })
            .catch((err: any) => {
                console.log("in axios ", err);
                store.state = "error";
            });
    }

    @computed
    get user_subject_array() {
        var retval: string[] = [];
        this.userSubjects.forEach(function(v, k) {
            retval.push(v.hash_key);
        });

        return retval;
    }

    get_current_subject() {
        var subjectSlug = this.rootStore.uiStore.subject_detail_slug;
        var user = this.rootStore.uiStore.subject_detail_user;
        var getSlug = `${user}/${subjectSlug}`;

        return this.subjects.get(getSlug);
    }

    get_current_user_subject() {
        var subjectSlug = this.rootStore.uiStore.subject_detail_slug;
        var user = this.rootStore.uiStore.subject_detail_user;
        var getSlug = `${user}/${subjectSlug}`;

        return this.userSubjects.get(getSlug);
    }

    nestedQuizObjects(subjectHashKey: any) {
        let subject = this.subjects.get(subjectHashKey);
        let userSubject = this.userSubjects.get(subjectHashKey);

        let nested_object_ids: Array<any> = [];
        let returned_objects = new Map();

        if (!subject) return returned_objects;

        subject.objects.forEach((quiz_object: QuizObject, i: number) => {
            if (quiz_object.card_tables.length == 0) return;

            console.log(quiz_object.card_tables);
            quiz_object.card_tables.forEach((cardTable: QuizObjectCardTable, i: number) => {
                cardTable.cards.forEach((card) => {
                    nested_object_ids.push(card._id);
                });
            });
        });

        subject.objects.forEach((quiz_object: QuizObject, i: number) => {
            if (nested_object_ids.includes(quiz_object._id)) return;
            returned_objects.set(quiz_object._id, quiz_object);
        });

        return returned_objects;
    }

    private redirectIfNotLoggedIn(res: IResponse) {
        if (res.status === 403) {
            window.location.href = "/login";
        }
        return res.data;
    }


}

export {
    Subject, UserSubject
}
